module.exports = __webpack_public_path__ + "static/MIOTA-e62c4442b32db84a4426248d89e7202f.svg";